export const flagStyles = {
    default: {
        width: 24,
        height: 16,
        borderRadius: "2px",
        display: "inline-block",
        overflow: "hidden",
    },
    germany: {
        width: 24,
        height: 16,
        background: "linear-gradient(to bottom, #000 33%, #d00 33%, #d00 66%, #ffce00 66%)",
        borderRadius: "2px",
        display: "inline-block",
    },
    adornmentBox: {
        display: "flex",
        alignItems: "center",
        gap: 1,
    },
    prefix: {
        minWidth: "35px",
    },
}
